const LOGO_TEXT_KEYS = ['logoText', 'logo_text', 'LogoText'];

const readValue = (value) =>
    value && typeof value === 'object' && 'value' in value
        ? value.value
        : value;

const hasOwn = (object, key) =>
    Boolean(object) && Object.prototype.hasOwnProperty.call(object, key);

const entityToChar = (match, value, radix) => {
    const codePoint = parseInt(value, radix);
    if (!Number.isFinite(codePoint) || codePoint < 0 || codePoint > 0x10ffff) {
        return match;
    }

    return String.fromCodePoint(codePoint);
};

export const decodeLogoTextEntities = (value) =>
    String(readValue(value) ?? '')
        .replace(/&amp;(#[0-9]+;|#x[0-9a-f]+;|nbsp;)/gi, '&$1')
        .replace(/&nbsp;|&#160;|&#xa0;/gi, ' ')
        .replace(/&#x([0-9a-f]+);/gi, (match, hex) =>
            entityToChar(match, hex, 16)
        )
        .replace(/&#([0-9]+);/g, (match, decimal) =>
            entityToChar(match, decimal, 10)
        );

export const getLogoTextOverride = (company = {}) => {
    const explicitKey = LOGO_TEXT_KEYS.find((key) => hasOwn(company, key));

    return {
        hasExplicitValue: Boolean(explicitKey),
        value: explicitKey
            ? decodeLogoTextEntities(company?.[explicitKey])
            : '',
    };
};

export const resolveLogoText = (company, legacyLogoText) => {
    const override = getLogoTextOverride(company);
    if (override.hasExplicitValue) return override.value.trim();

    return decodeLogoTextEntities(legacyLogoText).trim();
};
